import { webapi } from '@/api/webapi.ts';
import { activeOrdersList } from '@/store/blotter/api/activeOrdersList.ts';
import { historicalTradesList } from '@/store/blotter/api/historicalTradesList.ts';
import { openInXone } from '@/store/blotter/api/openInXone.ts';
import { register } from '@/store/blotter/api/register.ts';
import { todayTradesList } from '@/store/blotter/api/todayTradesList.ts';

export const blotterApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    register: register(builder),
    getTodayTradesList: todayTradesList(builder),
    getHistoricalTradesList: historicalTradesList(builder),
    getActiveOrdersList: activeOrdersList(builder),
    openInXone: openInXone(builder),
  }),
});
